import { Component } from '@angular/core';
import { DatePickerComponent, ErrorComponent } from '@group24ag/flowkit';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

@Component({
  imports: [
    DatePickerComponent,
    ErrorComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
  selector: 'app-ui-date-picker',
  template: `
    <div class="max-w-96">
      <h1 class="heading-title">Date Picker</h1>
      <div class="flex flex-col gap-10">
        <flk-date-picker
          [(ngModel)]="simpleDate"
          [label]="'Date'"
          [placeholder]="'Select a date'"
          class="w-full" />
        <flk-date-picker
          [formControl]="requiredControl"
          [label]="'Required date'"
          [placeholder]="'Pick a date'"
          class="w-full">
          <flk-error>Date is required</flk-error>
        </flk-date-picker>
        <flk-date-picker
          [formControl]="disabledControl"
          [label]="'Disabled'"
          [placeholder]="'Pick a date'"
          class="w-full" />
        <flk-date-picker
          [formControl]="rangeControl"
          [label]="'With range (today ± 7 days)'"
          [placeholder]="'Pick within range'"
          [min]="minDate"
          [max]="maxDate"
          class="w-full" />
      </div>
    </div>
  `,
})
export class UIDatePickerComponent {
  /** Simple two-way binding example **/
  simpleDate: Date | null = null;

  /** Required form control to showcase validation **/
  readonly requiredControl = new FormControl<Date | null>(null, [
    Validators.required,
  ]);

  /** Pre-filled disabled control **/
  readonly disabledControl = new FormControl<Date | null>({
    value: new Date(),
    disabled: true,
  });

  /** Control with min/max date constraints **/
  readonly rangeControl = new FormControl<Date | null>(null);

  /** Earliest selectable date: 7 days ago **/
  readonly minDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);

  /** Latest selectable date: 7 days from now **/
  readonly maxDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000);
}
